"use client";

import React from "react";
import { motion } from "framer-motion";

const FinalCTA = () => {
  return (
    <section className="w-full bg-[#F9FAFB] py-16 sm:py-20 md:py-24 px-4 sm:px-6 text-center border-t-10 border-[#4177BC] rounded-t-3xl">
      {/* --- Heading --- */}
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[64px] judson-regular text-[#000000] mb-5 sm:mb-6 leading-snug max-w-3xl mx-auto px-2"
      >
        Ready for a better real estate experience?
      </motion.h2>

      {/* --- Description --- */}
      <motion.p
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="text-[#6B7280] inter-regular text-sm sm:text-base md:text-lg max-w-2xl mx-auto mb-8 sm:mb-10 leading-relaxed"
      >
        Whether you’re buying your first home, selling a property, or growing
        your real estate business — AskLocal connects you with the right people,
        tools, and insights to make it happen.
      </motion.p>

      {/* --- Button --- */}

      <motion.div
        onClick={() => {
          // 1️⃣ scroll to top
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });

          // 2️⃣ wait for scroll animation, then open modal
          setTimeout(() => {
            window.dispatchEvent(new Event("openAskLocalConcierge"));
          }, 600); // timing tuned for smooth UX
        }}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="flex justify-center"
      >
        <button className="bg-[#EB9C2C] hover:bg-[#4177BC] text-white font-semibold text-sm sm:text-base px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg shadow-md transition-all duration-300">
          Start Your Free AskLocal Concierge
        </button>
      </motion.div>
    </section>
  );
};

export default FinalCTA;
